import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  pins: [],
  // The own proposition the pins were fetched for — swap details must be
  // computed against the same proposition, not blindly the primary one.
  pinsPropositionId: null,
  selectedPinId: null,
  // Proposition id of the feed card being hovered — highlights its pin
  // or freemium circle on the side map.
  hoveredPropositionId: null,
  selectedSuggestion: null,
  selectedSuggestions: [],
  suggestionCache: {},
  loadingPins: false,
  loadingSuggestion: false
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
